function sectionRedering() {
  fetch("?section_id=cart-drawer")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".cart-drawer__main-wrapper", cart__html);
      $(".cart-drawer__main-wrapper").replaceWith(render__html);
      var render__html = $(".cart-drawer__top em", cart__html);
      $(".cart-drawer__top em").replaceWith(render__html);

    });

  // // header 
  fetch("?section_id=header")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".header__cart em", cart__html);
      $(".header__cart em").replaceWith(render__html);
      var render__html = $(".header__cart sup", cart__html);
      $(".header__cart sup").replaceWith(render__html);
    });

}










function selectedVarint() {
  var slectedId = $(".select__variant").val();
  var url = new URL(window.location.href);
  url.searchParams.set("variant", slectedId);
  window.history.replaceState({}, "", url);
}


//   // match variant

function matchVariant() {
  var updateValue = "";
  $(".product__about-type input[type='radio']:checked").each(function () {

    updateValue += (updateValue ? " / " : "") + $(this).val();
  })

  var isMatchFound = false;
  if($(".select__variant option").length > 0){
    $(".select__variant option").each(function () {
      var optionValue = $(this).text().trim();

      if (updateValue.toLowerCase() == optionValue.toLowerCase()) {
        isMatchFound = true;
        $(this).prop("selected", true);


        var variant__available = $(this).attr("data-variant-available");
        var variant__price = $(this).attr("data-variant-price");
        var klarna_price = $(this).attr("data-variant-klarna-price");

        //   $(".product__color span").text(optionValue);
        $(".price-display").text(variant__price);
        $(".klarna-price").text(klarna_price);
        if (variant__available == 'false') {
          $(".product__main-btn").addClass("disabled");
        } else {
          $(".product__main-btn").removeClass("disabled");

        }
      }
      return true;

    });
  } else {
    var $this = $(".select__variant");
    var variant__available = $this.attr("data-variant-available");
    var variant__price = $this.attr("data-variant-price");
    var klarna_price = $this.attr("data-variant-klarna-price");
    $(".price-display").text(variant__price);
    $(".klarna-price").text(klarna_price);
    if (variant__available == 'false') {
      $(".product__main-btn").addClass("disabled");
    } else {
      $(".product__main-btn").removeClass("disabled");
    }
  }


}

$(".product__about-type input[type='radio']").change(function () {
  matchVariant();
  selectedVarint();
})
$(document).ready(function () {
  matchVariant();
});


$(".product__main-btn").on("click", function (e) {
  e.preventDefault();
  $(".product__main-button-cart").addClass("loading");
  formData = $(this).closest(".single__product-add-pro").serialize();
  addToCart(formData)
});



function addToCart(formData) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: formData,
    success: function (data) {
       $(".product__main-button-cart").removeClass("loading");
      $("body").addClass("cart-drawer-open");
      sectionRedering();

    },
    error: function (err) {
      console.log(err);
    },
  });
};





$("#MainContent").on("click",".product__look-btn", function (e) {
  e.preventDefault(); 
  $(".product__look-btn-wrap").addClass("loading");
  var variantId = $(this).attr('data-upsell-product-id');
  var data = {
    id: variantId,
    quantity: 1
  };

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (response) {
      $(".product__look-btn-wrap").removeClass("loading");
      $("body").addClass("cart-drawer-open");
      sectionRedering();
    },
    error: function (err) {
      console.log("Error adding product to cart:", err);
    }
  });
})






$(document).on("click", ".dropdown-menu div", function () {
  var quantity = $(this).data("value");
  var dropdown = $(this).closest(".dropdown");
  var data_line = dropdown.data("line");

  dropdown.find(".dropdown-value").text(quantity);

  changeQuantity(dropdown, quantity, data_line);
});

function changeQuantity(dropdown, quantity, line) {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      line: line,
      quantity: quantity
    },
    success: function (data) {
      // console.log("Cart updated", data);
      sectionRedering();
    },
    error: function () {
      console.log("Error from quantity update");
    }
  });
}





// $(document).on("click", ".dropdown-menu div", function () {
//   var addQty = parseInt($(this).data("value")); 
//   var dropdown = $(this).closest(".dropdown");
//   var data_line = dropdown.data("line");

//   var currentQty = parseInt(dropdown.find(".dropdown-value").text());

//   var newQty = currentQty + addQty;

//   dropdown.find(".dropdown-value").text(newQty);

//   changeQuantity(dropdown, newQty, data_line);
// });

// function changeQuantity(dropdown, quantity, line) {
//   $.ajax({
//     type: "POST",
//     url: "/cart/change.js",
//     dataType: "json",
//     data: {
//       line: line,
//       quantity: quantity
//     },
//     success: function (data) {
//       console.log("Cart updated", data);
//       sectionRedering(); 
//     },
//     error: function () {
//       console.log("Error from quantity update");
//     }
//   });
// }




function openDropdown(el) {
  const dropdown = el.parentElement;
  const menu = el.nextElementSibling;

  document.querySelectorAll(".dropdown-menu").forEach(m => {
    if (m !== menu) {
      m.style.display = "none";
    }
  });

  if (menu.style.display === "block") {
    menu.style.display = "none";
  } else {
    menu.style.display = "block";
  }
}

document.addEventListener("click", (e) => {
  if (!e.target.closest(".dropdown")) {
    document.querySelectorAll(".dropdown-menu").forEach(m => {
      m.style.display = "none";
    });
  }
});







// increment quantity in cart drawer
// function increment(el) {
//   var input = el.previousElementSibling;
//   var value = parseInt(input.value);
//   console.log(value)
//   value = isNaN(value) ? 0 : value
//   value++;
//   input.value = value;
//   changeQuantity(input);

// }
// // decrement quantity in cart drawer
// function decrement(el) {
//   var input = el.nextElementSibling;
//   var value = parseInt(input.value);
//   if (value > 0) {
//     value = isNaN(value) ? 0 : value;
//     value--;
//     input.value = value;
//     changeQuantity(input);
//   }
// }

// function changeQuantity(input) {

//   var quantity = $(input).val();
//   var data_line = $(input).attr("data-line");
//   var data = {
//     "line": data_line,
//     "quantity": quantity
//   };
//   $.ajax({
//     type: "POST",
//     url: "/cart/change.js",
//     dataType: "json",
//     data: data,
//     success: function (data) {
//       console.log(data);
//       sectionRedering();
//     },
//     error: function (err) {
//       console.log("Error from quantity update")
//     }
//   })


// }


$(document).on("click", ".cart-drawer__product-dlt", function (event) {
  event.preventDefault();
  var data_line = $(this).data("line");

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      line: data_line,
      quantity: 0
    },
    success: function (data) {
      sectionRedering(); 
    },
    error: function () {
      console.log("Error removing item");
    }
  });
});
